import EventEmitter from "events";

export default class Time extends EventEmitter {
  constructor() {
    super();

    this.start = Date.now();
    this.current = this.start;
    this.elapsed = 0;
    this.delta = 16;

    this.tick = this.tick.bind(this);
    this.tick();
  }

  tick() {
    this.ticker = window.requestAnimationFrame(this.tick);

    const current = Date.now();

    this.delta = current - this.current;
    this.elapsed = current - this.start;
    this.current = current;

    this.delta /= 1000;

    this.emit("tick", this.delta);
  }

  stop() {
    window.cancelAnimationFrame(this.ticker);
  }
}
